import img1 from "../../assets/project1/img1.svg";
import img2 from "../../assets/project1/img2.svg";
import img3 from "../../assets/project1/img3.svg";
import img4 from "../../assets/project2/img1.svg";
import img5 from "../../assets/project2/img2.svg";
import img6 from "../../assets/project3/img1.svg";
import img7 from "../../assets/project3/img2.svg";
import img8 from "../../assets/project4/7.png";
import img9 from "../../assets/project4/8.png";
import img10 from "../../assets/project5/9.png";
import img11 from "../../assets/project5/10.png";

export const Projects = [
  {
    id: "1",
    title: "Android Video Streaming App",
    type: "Android",
    url: "https://github.com/abhyudaya001/abTube",
    imgs: [img1, img2, img3],
    desc: "Application to provide best video streaming experience which is extremely fast without any buffering delay and without any disturbance from ads. Provides the user with the functionality to stream videos in both online and offline mode.",
  },
  {
    id: "2",
    title:
      "StuNet ( A Social media site for CS student build using MERN Stack )",
    type: "Web",
    url: "https://github.com/abhyudaya001/TheStudentNetwork",
    imgs: [img4, img5],
    desc: "The MERN stack-based web app enables computer science students to post academic queries, which are made accessible to users via a recommendation system. The system uses advanced algorithms to suggest personalized queries to each user. The app is designed to improve the learning experience for students and facilitate access to quality information.",
  },
  {
    id: "3",
    title: "TheITJobBoard (Job Posting Site build using MERN STACK )",
    type: "Web",
    url: "https://github.com/abhyudaya001/TheITJobBoard",
    imgs: [img6, img7],
    desc: "TheITJobBoard is a job posting site built using the MERN stack, aimed at connecting job seekers with IT-related job opportunities. The platform provides a comprehensive database of job listings for IT positions, covering a wide range of roles and companies. The project aims to simplify the job search process for job seekers and help employers find suitable candidates for their open positions.",
  },
  {
    id: "4",
    title: "Implement OTP verification on a food ordering website",
    type: "Web",
    url: "https://github.com/abhyudaya001/jhatpat",
    imgs: [img8, img9],
    desc: "The purpose of OTP verification is to enhance the security of the food ordering website by ensuring that users provide a valid and verified contact number during the registration or checkout process. This helps prevent fraudulent activities and unauthorized access.",
  },
  {
    id: "5",
    title: "Gadget review Website",
    type: "Web",
    url: "https://github.com/abhyudaya001/gadget_review",
    imgs: [img10, img11],
    desc: "Gadget review website where users can sign up and log in to add their reviews for any gadget. The website provides a platform for users to share their opinions and experiences on various gadgets.",
  },
];
